__turbopack_context__.v({
  "accordion": "accordion-module-scss-module__GoEIuG__accordion",
  "accordionlist": "accordion-module-scss-module__GoEIuG__accordionlist",
  "accordionpanel": "accordion-module-scss-module__GoEIuG__accordionpanel",
});
